import { render, staticRenderFns } from "./PatientDemographicsCreateDialog.vue?vue&type=template&id=22772e46&"
import script from "./PatientDemographicsCreateDialog.vue?vue&type=script&lang=js&"
export * from "./PatientDemographicsCreateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VListItemContent})
